export default {"src":"/au/_next/static/media/AW-Workmanship&Quality.a3922ada.svg","height":120,"width":200,"blurWidth":0,"blurHeight":0};